import React from "react";

export default function BriefCaseIcon() {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="suitcase customSvG"
    >
      <g clipPath="url(#clip0_408_11979)">
        <path
          d="M8.75033 4.8032C8.42833 4.8032 8.16699 4.52457 8.16699 4.18124V3.24831H5.83366V4.18124C5.83366 4.52457 5.57233 4.8032 5.25033 4.8032C4.92833 4.8032 4.66699 4.52457 4.66699 4.18124V3.24831C4.66699 2.56229 5.19024 2.00439 5.83366 2.00439H8.16699C8.81041 2.00439 9.33366 2.56229 9.33366 3.24831V4.18124C9.33366 4.52457 9.07233 4.8032 8.75033 4.8032Z"
          fill="white"
        />
        <path
          d="M7.41417 10.3266C7.30917 10.3701 7.1575 10.4012 7 10.4012C6.8425 10.4012 6.69083 10.3701 6.55083 10.3142L0 7.98804V12.7336C0 13.6789 0.7175 14.444 1.60417 14.444H12.3958C13.2825 14.444 14 13.6789 14 12.7336V7.98804L7.41417 10.3266Z"
          fill="white"
        />
        <path
          d="M14 5.58074V7.00503L7.14 9.4431C7.09333 9.46176 7.04667 9.46798 7 9.46798C6.95333 9.46798 6.90667 9.46176 6.86 9.4431L0 7.00503V5.58074C0 4.63537 0.7175 3.87036 1.60417 3.87036H12.3958C13.2825 3.87036 14 4.63537 14 5.58074Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_408_11979">
          <rect
            width="14"
            height="14.927"
            fill="white"
            transform="translate(0 0.760498)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
